export const BROADCAST_CHANNEL_NAME = "refresh";
export const REFRESH_SESSION_MESSAGE = "REFRESH_SESSION";

// Generate a unique ID for this tab
export const TAB_ID = Math.random().toString(36).substring(2, 15);

export interface SessionMessage {
  type: string;
  sourceTabId: string;
}

// Helper to broadcast session changes to other tabs
export const broadcastToOtherTabs = () => {
  const authChannel = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
  authChannel.postMessage({ type: REFRESH_SESSION_MESSAGE, sourceTabId: TAB_ID });
  authChannel.close();
};